"use client"

import { ModalTypes } from "@/interfaces/api/generic/api_modals_types"
import { ReactNode } from "react"
import { create } from "zustand"

interface ModalStore {
  isOpen: boolean
  type: ModalTypes
  content: ReactNode | null
  closeOnBackdrop: boolean
  showAge18: boolean
  openModal: (args: { content: ReactNode; type?: ModalTypes; closeOnBackdrop?: boolean }) => void
  closeModal: () => void
  setShowAge18: (value: boolean) => void
}

export const useModalStore = create<ModalStore>((set) => ({
	isOpen: false,
  type: ModalTypes.NATIVE,
  content: null,
  closeOnBackdrop: true,
  showAge18: true,

  /**
   * Open a modal
   * 
   * @param params
   */
	openModal: ({ content, type = ModalTypes.NATIVE, closeOnBackdrop = true }) => {
		set({
      isOpen: true,
      content,
      type,
      closeOnBackdrop
    })
	},

  /**
   * Close the current modal
   */
  closeModal: () => {
    set({
      isOpen: false,
      content: null
    })
  },

  /**
   * Store the confirmation that a user is of legal age, even when not logged in,
   * so the modal is not shown again during the session
   * 
   * @param value Boolean confirming the user is of legal age
   */
  setShowAge18: (value) => {
    set({
      showAge18: value
    })
  }
	}),
)